import { allow } from '../classes/allow';
import local from '../classes/local';
import getDateStringFromObject from '../functions/get.date.string.from.object';
import { stripInvalidMbiChars } from '../functions/strip.invalid.mbi.chars';
import is from '../objects/is';
import dateFieldValue from '../objects/models/date.field.value';
import the from '../objects/the';
import use from '../objects/use';
import useAxios from './use.axios';

export default function useCreateAccountApi() {
   const axios = useAxios();
   const data = use.createAccountData;
   
   const step1 = async (mbi = '', effectiveDate = dateFieldValue, effectiveDatePart = '') => {
      allow.aString(mbi, is.not.empty).anInstanceOf(effectiveDate, dateFieldValue).oneOf(effectiveDatePart, the.part);
      data.coverageStartDate.set(effectiveDate);
      data.medicareNumber.set(mbi);
      data.part.set(effectiveDatePart);
      return await axios.call(
         the.method.post,
         process.env.REACT_APP_API_ENDPOINT + '/create-account/step/1',
         {
            effectiveDate: getDateStringFromObject(data.coverageStartDate.get()),
            effectiveDatePart: data.part.get().toLowerCase(),
            mbi: stripInvalidMbiChars(data.medicareNumber.get()),
         },
         the.defaultHeader,
      );
   };
   
   const step2 = async (lastName = '', dateOfBirth = dateFieldValue, zipCodeOrCity = '', email = '') => {
      allow.aString(lastName, is.not.empty).anInstanceOf(dateOfBirth, dateFieldValue).aString(zipCodeOrCity, is.not.empty).aString(email);
      data.emailAddress.set(email);
      data.lastName.set(lastName);
      data.dateOfBirth.set(dateOfBirth);
      data.zipCodeOrCity.set(zipCodeOrCity);
      const requestData = {
         dateOfBirth: getDateStringFromObject(data.dateOfBirth.get()),
         effectiveDate: getDateStringFromObject(data.coverageStartDate.get()),
         effectiveDatePart: data.part.get().toLowerCase(),
         lastName: data.lastName.get(),
         mbi: stripInvalidMbiChars(data.medicareNumber.get()),
         zipCodeOrCity: data.zipCodeOrCity.get(),
      };
      if (data.emailAddress.get())
         requestData.email = data.emailAddress.get();
      return await axios.call(
         the.method.post,
         process.env.REACT_APP_API_ENDPOINT + '/create-account/step/2',
         requestData,
         the.defaultHeader,
      );
   };
   
   const step3 = async (username = '', password = '', challengeQuestion = '', challengeAnswer = '') => {
      const language = local.getItem('language', 'English');
      allow.aString(username, is.not.empty).aString(password, is.not.empty).oneOf(challengeQuestion, the.secretQuestions.English).aString(challengeAnswer, is.not.empty);
      data.password.set(password);
      data.secretAnswer.set(challengeAnswer);
      data.secretQuestion.set(challengeQuestion);
      data.username.set(username);
      const submittedData = {
         challengeQuestionAndAnswers: [{
            answer: data.secretAnswer.get(),
            question: data.secretQuestion.get(),
         }],
         dateOfBirth: getDateStringFromObject(data.dateOfBirth.get()),
         effectiveDate: getDateStringFromObject(data.coverageStartDate.get()),
         effectiveDatePart: data.part.get().toLowerCase(),
         lang: language === 'English' ? 'en' : 'es',
         lastName: data.lastName.get(),
         mbi: stripInvalidMbiChars(data.medicareNumber.get()),
         password: data.password.get(),
         username: data.username.get(),
         zipCodeOrCity: data.zipCodeOrCity.get(),
      };
      if (data.emailAddress.get() !== '')
         submittedData.email = data.emailAddress.get();
      return await axios.call(
         the.method.post,
         process.env.REACT_APP_API_ENDPOINT + '/create-account/step/3',
         submittedData,
         the.defaultHeader,
      );
   };
   
   return {
      step1,
      step2,
      step3,
   };
}